<section class="info-shipment-main" [ngClass]="{ 'is-valid': isShipmentValid }">
  <header class="info-shipment-main-header lg">
    <div class="info-shipment-main-header-text">
      <h3>{{ "INFO.SHIP.TITLE" | translate }}</h3>

      <img src="/assets/icons/icon_plain.svg" *ngIf="isAir" />
      <img src="/assets/icons/icon_vessel.svg" *ngIf="isOcean" />
      <img src="/assets/icons/icon_rail.svg" *ngIf="isRail" />
      <img src="/assets/icons/icon_truck_sm.svg" *ngIf="isTruck" />

      <div class="info-shipment-main-header-details" *ngIf="!isTruck">
        <div class="row" *ngIf="!isAir && !isRail">
          <div class="col-12 card-label">{{ "LABELS.VESSEL_NAME" | translate }}</div>
          <div class="col-12" [ngClass]="{ 'text-error': !entrySummary.vesselName }">
            {{ entrySummary.vesselName ? entrySummary.vesselName : ("LABELS.MISSING" | translate) }}
          </div>
        </div>

        <div class="row">
          <div class="col-12 card-label">
            <span *ngIf="isAir">{{ "FORM_LABEL.FLIGHT_NUMBER" | translate }}</span>
            <span *ngIf="isOcean">{{ "LABELS.VOYAGE_NUMBER" | translate }}</span>
            <span *ngIf="isRail">{{ "FORM_LABEL.RAIL_TRIP_NUMBER" | translate }}</span>
          </div>
          <div class="col-12" [ngClass]="{ 'text-error': !entrySummary.trip }">
            {{ entrySummary.trip ? entrySummary.trip : ("LABELS.MISSING" | translate) }}
          </div>
        </div>

        <div class="row" *ngIf="isShowType">
          <div class="col-12 card-label">
            {{ "LABELS.TYPE" | translate }}
          </div>
          <div class="col-12">
            {{ (entrySummary?.type === enumEntrySummaryType.FORMAL ? "FORM_LABEL.FORMAL" : "FORM_LABEL.INFORMAL") | translate }}
          </div>
        </div>
      </div>
    </div>
    <div class="info-shipment-main-header-actions">
      <button type="button" class="btn btn-link" *ngIf="isCanEditDetails" (click)="editDetails.emit()">
        <svg width="19" height="19" viewBox="0 0 19 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 14.2525V18.0025H3.75L14.81 6.9425L11.06 3.1925L0 14.2525ZM17.71 4.0425C18.1 3.6525 18.1 3.0225 17.71 2.6325L15.37 0.2925C14.98 -0.0975 14.35 -0.0975 13.96 0.2925L12.13 2.1225L15.88 5.8725L17.71 4.0425Z"
            fill="currentColor"
          />
        </svg>

        <span class="ml-2">{{ "BUTTON.EDIT" | translate }}</span>
      </button>

      <button type="button" class="btn btn-link ml-3 btn-arrow" (click)="isBodyOpen = !isBodyOpen">
        <i class="fa" [ngClass]="{ 'fa-chevron-up': isBodyOpen, 'fa-chevron-down': !isBodyOpen }"></i>
      </button>
    </div>
  </header>
  <div class="info-shipment-main-body info-shipment-main-body-details" *ngIf="isBodyOpen">
    <div class="info-shipment-main-body-details-summary first-line" *ngIf="isShowFirstLine">
      <div class="info-shipment-item-wrapper">
        <div class="info-shipment-item">
          <!--#12041-->
          <desktop-summary-entity
            [entity]="entrySummary?.importer"
            [isShowIdentifier]="true"
            [entityCode]="enumEntityModelCode.IMPORTER"
            [isEditMode]="false"
            [isShowEncircledButton]="true"
            [sameAs]="importerSameAsCompany()"
            (edit)="editMF.emit()"
          ></desktop-summary-entity>
        </div>
      </div>

      <div class="info-shipment-item-wrapper">
        <div
          class="info-shipment-item"
          [ngClass]="{
            'has-error': hasShipmentError || suretyCodeErrorText || referenceNumberErrorText || bondTypeErrorText,
            'is-editable': isCanEdit
          }"
        >
          <div class="info-shipment-item-header">
            <h3>{{ "LABELS.SHIPMENT_DETAILS" | translate }}</h3>

            <button
              type="button"
              class="btn btn-link d-print-none ml-2"
              [ngClass]="{ 'info-shipment-main__edit-button': isHasEsOcrRedesign }"
              *ngIf="canEditShipmentType ?? isCanEdit"
              (click)="editShipmentType.emit()"
            >
              <svg width="19" height="19" viewBox="0 0 19 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0 14.2525V18.0025H3.75L14.81 6.9425L11.06 3.1925L0 14.2525ZM17.71 4.0425C18.1 3.6525 18.1 3.0225 17.71 2.6325L15.37 0.2925C14.98 -0.0975 14.35 -0.0975 13.96 0.2925L12.13 2.1225L15.88 5.8725L17.71 4.0425Z"
                  fill="currentColor"
                />
              </svg>
            </button>
          </div>

          <div class="shipment-details-row">
            <div class="shipment-details-key">{{ "LABELS.TYPE" | translate }}</div>

            <div class="shipment-details-value">
              <span [ngClass]="{ 'text-error': hasShipmentError }">
                {{ (entrySummary?.type === enumEntrySummaryType.FORMAL ? "FORM_LABEL.FORMAL" : "FORM_LABEL.INFORMAL") | translate }}
              </span>
            </div>
          </div>

          <div class="shipment-details-row">
            <div class="shipment-details-key">{{ "LABELS.GOODS_VALUE" | translate }}</div>

            <div class="shipment-details-value">
              <span [ngClass]="{ 'text-error': hasShipmentError }">
                {{ enteredValue | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}
              </span>
            </div>
          </div>

          <ng-container *ngIf="entrySummary.type !== enumEntrySummaryType.INFORMAL">
            <ng-container *ngIf="bondInfo && (!(singleBondRequest || continuousBondRequest) || hasCanceledBondRequest)">
              <div class="shipment-details-row" *ngIf="bondInfo">
                <div class="shipment-details-key">{{ "LABELS.BOND_TYPE" | translate }}</div>
                <div class="shipment-details-value">{{ bondTypeLabel | translate }}</div>
              </div>
              <div class="shipment-details-row" *ngIf="bondInfo?.suretyCode">
                <div class="shipment-details-key">{{ "SURETY" | translate }}</div>
                <div class="shipment-details-value">{{ bondInfo.suretyCode }}</div>
              </div>
              <div class="shipment-details-row" *ngIf="isSingleBondType && bondInfo?.referenceNumber">
                <div class="shipment-details-key">{{ "LABELS.BOND_REFERENCE_NUMBER" | translate }}</div>
                <div class="shipment-details-value">{{ bondInfo.referenceNumber }}</div>
              </div>
              <div class="shipment-details-row" *ngIf="bondInfo?.bondAmount">
                <div class="shipment-details-key">{{ "BOND_COVERAGE" | translate }}</div>
                <div class="shipment-details-value">{{ bondInfo.bondAmount | currency : DEFAULT_CURRENCY_CODE : "symbol" : "1.2-2" }}</div>
              </div>
            </ng-container>
            <ng-container *ngIf="singleBondRequest">
              <div class="shipment-details-card-bond">
                <div class="shipment-details-row">
                  <h3>{{ singleBondText | translate }}</h3>
                </div>

                <div class="shipment-details-row" *ngIf="isShowBR">
                  <div class="shipment-details-key">{{ "LABELS.BOND_REQUEST_NUMBER" | translate }}</div>
                  <div class="shipment-details-value">
                    <a href="" [routerLink]="['/bond-requests-management', bondRequest?.id]">{{ bondRequest?.referenceNumber }}</a>
                  </div>
                </div>

                <div class="shipment-details-row" *ngIf="singleBondRequest?.portCode">
                  <div class="shipment-details-key">{{ "LABELS.ARRIVAL_PORT" | translate }}</div>
                  <div class="shipment-details-value">
                    {{ arrivalPort ? arrivalPort.code + " " + arrivalPort.description : singleBondRequest.portCode }}
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="continuousBondRequest">
              <div class="shipment-details-card-bond">
                <div class="shipment-details-row">
                  <h3>{{ "INFO.BN.CONTINUOUS_BOND_PURCHASE_REQUESTED" | translate }}</h3>
                </div>
                <div class="shipment-details-row" *ngIf="continuousBondRequest.continuousBondDetails?.importerNumber">
                  <div class="shipment-details-key">{{ "FORM_LABEL.IMPORTER_IDENTIFIER" | translate }}</div>
                  <div class="shipment-details-value">
                    {{ continuousBondRequest.continuousBondDetails.importerNumber }}
                  </div>
                </div>
                <div class="shipment-details-row" *ngIf="continuousBondRequest.continuousBondDetails?.companyName">
                  <div class="shipment-details-key">{{ "FORM_LABEL.IMPORTER_NAME" | translate }}</div>
                  <div class="shipment-details-value">{{ continuousBondRequest.continuousBondDetails.companyName }}</div>
                </div>
                <div class="shipment-details-row">
                  <div class="shipment-details-key">{{ "FORM_LABEL.STATE" | translate }}</div>
                  <div class="shipment-details-value">
                    <div>
                      {{ "BOND_REQUEST_STATE." + enumBondRequestState[continuousBondRequest.state] | translate }}
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>

          <ng-container>
            <div class="price-notifications" *ngIf="!!sumValidation">
              <div class="price-notifications-icon">
                <span class="icon-ic_big_v"></span>
              </div>
              <div class="price-notifications-text">
                <span [innerHTML]="'BACK_ERROR.' + sumValidation | translate : { total: enteredValue }"></span>
              </div>
            </div>
          </ng-container>

          <div class="shipment-details-row d-block">
            <p class="w-100 text-error m-0" *ngIf="suretyCodeErrorText">
              {{ suretyCodeErrorText | translate }}
            </p>

            <p class="w-100 text-error m-0" *ngIf="referenceNumberErrorText">
              {{ referenceNumberErrorText | translate }}
            </p>

            <p class="w-100 text-error m-0" *ngIf="bondTypeErrorText">
              {{ bondTypeErrorText | translate }}
            </p>
          </div>
        </div>
      </div>

      <div class="info-shipment-item-wrapper is-last">
        <div class="info-shipment-item is-last" [ngClass]="{ 'has-error': isEmpty, 'is-editable': isCanEdit }">
          <div class="info-shipment-item-header">
            <h3>{{ "LABELS.DUTIES_PAYMENT_TYPE" | translate }}</h3>

            <button
              type="button"
              class="btn btn-link d-print-none ml-2"
              [ngClass]="{ 'info-shipment-main__edit-button': isHasEsOcrRedesign }"
              *ngIf="isCanEdit && isShowDutiesPaymentType"
              (click)="editDutiesPaymentType.emit()"
            >
              <svg width="19" height="19" viewBox="0 0 19 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0 14.2525V18.0025H3.75L14.81 6.9425L11.06 3.1925L0 14.2525ZM17.71 4.0425C18.1 3.6525 18.1 3.0225 17.71 2.6325L15.37 0.2925C14.98 -0.0975 14.35 -0.0975 13.96 0.2925L12.13 2.1225L15.88 5.8725L17.71 4.0425Z"
                  fill="currentColor"
                />
              </svg>
            </button>
          </div>

          <div class="shipment-details-row">
            <div class="shipment-details-key">{{ (isHasEsOcrRedesign ? "LABELS.METHOD" : "LABELS.DUTIES_PAYMENT_TYPE") | translate }}</div>

            <div class="shipment-details-value">
              <span>
                {{
                  (entrySummary?.dutiesPaymentType === enumEntrySummaryDutiesPaymentType.ACH
                    ? isHasEsOcrRedesign
                      ? "LABELS.ACH"
                      : "DUTIES_PAYMENT_TYPE.ACH"
                    : "DUTIES_PAYMENT_TYPE.INSTANT"
                  ) | translate
                }}
              </span>
            </div>
          </div>

          <div class="shipment-details-row" *ngIf="entrySummary?.dutiesPaymentType === enumEntrySummaryDutiesPaymentType.ACH">
            <div class="shipment-details-key">{{ "LABELS.PAYER_UNIT_NUMBER_PUN" | translate }}</div>

            <div class="shipment-details-value">
              <span>
                {{ entrySummary?.payerUnitNumber }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="info-shipment-main-body-details-summary" [ngClass]="{ 'with-via': isWithVia }">
      <div class="info-shipment-item-wrapper">
        <div
          class="info-shipment-item"
          [ngClass]="{ 'has-error': isEmpty || isAnyFromFieldsMissing, 'is-editable': isCanEdit, 'with-via': isWithVia }"
        >
          <div class="info-shipment-item-header">
            <h3>{{ "LABELS.FROM" | translate }}</h3>

            <button
              type="button"
              class="btn btn-link d-print-none ml-2"
              [ngClass]="{ 'info-shipment-main__edit-button': isHasEsOcrRedesign }"
              *ngIf="(canEditFrom ?? isCanEdit) && !isAllFromFieldsMissing"
              (click)="editFrom.emit()"
            >
              <svg width="19" height="19" viewBox="0 0 19 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0 14.2525V18.0025H3.75L14.81 6.9425L11.06 3.1925L0 14.2525ZM17.71 4.0425C18.1 3.6525 18.1 3.0225 17.71 2.6325L15.37 0.2925C14.98 -0.0975 14.35 -0.0975 13.96 0.2925L12.13 2.1225L15.88 5.8725L17.71 4.0425Z"
                  fill="currentColor"
                />
              </svg>
            </button>
          </div>

          <div *ngIf="isAllFromFieldsMissing && (canEditFrom ?? isCanEdit)" class="info-shipment-item__missing-fields">
            <div class="info-shipment-item__missing-fields__edit-button" (click)="editFrom.emit()">
              <img class="info-shipment-item__missing-fields__edit-button__icon" src="assets/icons/icon_edit_gray_md.svg" alt="edit" />
            </div>
          </div>

          <ng-container *ngIf="!isAllFromFieldsMissing">
            <div class="info-shipment-item-row" *ngIf="!isAir && !isTruck">
              <div class="info-shipment-item-row-key">{{ "FORM_LABEL.FOREIGN_PORT" | translate }}</div>

              <div class="info-shipment-item-row-value" [ngClass]="{ 'text-error': foreignPortErrorText && !isHasEsOcrRedesign }">
                <span *ngIf="!foreignPortErrorText">
                  {{ foreignPort?.code }} {{ foreignPort?.portName }} {{ foreignPort?.countryCode }}
                </span>
                <span *ngIf="foreignPortErrorText && !isHasEsOcrRedesign">{{ foreignPortErrorText | translate }}</span>
                {{ isHasEsOcrRedesign && foreignPortErrorText ? "-----" : "" }}
              </div>
            </div>

            <div class="info-shipment-item-row">
              <div class="info-shipment-item-row-key">{{ "FORM_LABEL.EXPORT_DATE" | translate }}</div>
              <div class="info-shipment-item-row-value" [ngClass]="{ 'text-error': exportDateErrorText && !isHasEsOcrRedesign }">
                <span class="d-inline-block w-100" *ngIf="!exportDateErrorText">{{ exportDate | customDateByUtc }}</span>
                {{ isHasEsOcrRedesign && exportDateErrorText ? "-----" : "" }}
                <span *ngIf="!isHasEsOcrRedesign">
                  {{ exportDateErrorText | translate }}
                </span>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="info-shipment-item-wrapper" [ngClass]="{ 'is-last': !isWithVia }">
        <div
          class="info-shipment-item"
          [ngClass]="{ 'has-error': isEmpty || isAnyToFieldsMissing, 'is-editable': isCanEdit, 'is-last': !isWithVia }"
        >
          <div class="info-shipment-item-header">
            <h3>{{ "LABELS.TO" | translate }}</h3>

            <button
              type="button"
              class="btn btn-link d-print-none ml-2"
              [ngClass]="{ 'info-shipment-main__edit-button': isHasEsOcrRedesign }"
              *ngIf="(canEditTo ?? isCanEdit) && !isAllToFieldsMissing"
              (click)="editTo.emit()"
            >
              <svg width="19" height="19" viewBox="0 0 19 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0 14.2525V18.0025H3.75L14.81 6.9425L11.06 3.1925L0 14.2525ZM17.71 4.0425C18.1 3.6525 18.1 3.0225 17.71 2.6325L15.37 0.2925C14.98 -0.0975 14.35 -0.0975 13.96 0.2925L12.13 2.1225L15.88 5.8725L17.71 4.0425Z"
                  fill="currentColor"
                />
              </svg>
            </button>
          </div>

          <div *ngIf="isAllToFieldsMissing && (canEditTo ?? isCanEdit)" class="info-shipment-item__missing-fields">
            <div class="info-shipment-item__missing-fields__edit-button" (click)="editTo.emit()">
              <img class="info-shipment-item__missing-fields__edit-button__icon" src="assets/icons/icon_edit_gray_md.svg" alt="edit" />
            </div>
          </div>

          <ng-container *ngIf="!isAllToFieldsMissing">
            <div class="info-shipment-item-row" *ngIf="!isTruck || !!entrySummary?.locationCode">
              <div class="info-shipment-item-row-key">{{ "FORM_LABEL.LOCATION_OF_GOODS" | translate }}</div>
              <div class="info-shipment-item-row-value" [ngClass]="{ 'text-error': locationErrorText && !isHasEsOcrRedesign }">
                <span *ngIf="!locationErrorText">{{ location?.code }} {{ location?.name }}</span>
                <span *ngIf="!isHasEsOcrRedesign && locationErrorText">{{ locationErrorText | translate }}</span>
                <span *ngIf="isHasEsOcrRedesign && locationErrorText">-----</span>
              </div>
            </div>

            <div class="info-shipment-item-row">
              <div class="info-shipment-item-row-key">{{ "FORM_LABEL.PORT_OF_ENTRY" | translate }}</div>

              <div class="info-shipment-item-row-value" [ngClass]="{ 'text-error': entryErrorText && !isHasEsOcrRedesign }">
                <span *ngIf="!entryErrorText">{{ portOfEntry ? portOfEntry.code + " " + portOfEntry.description : "" }}</span>
                <span *ngIf="!isHasEsOcrRedesign && entryErrorText">{{ entryErrorText | translate }}</span>
                <span *ngIf="isHasEsOcrRedesign && entryErrorText">-----</span>
              </div>
            </div>

            <div class="info-shipment-item-row">
              <div class="info-shipment-item-row-key">{{ "FORM_LABEL.STATE_OF_DESTINATION" | translate }}</div>

              <div class="info-shipment-item-row-value" [ngClass]="{ 'text-error': destinationStateErrorText && !isHasEsOcrRedesign }">
                <span *ngIf="!destinationStateErrorText">{{ stateOfDestination?.description }}</span>
                <span *ngIf="!isHasEsOcrRedesign && destinationStateErrorText">{{ destinationStateErrorText | translate }}</span>
                <span *ngIf="isHasEsOcrRedesign && destinationStateErrorText">-----</span>
              </div>
            </div>

            <div class="info-shipment-item-row">
              <div class="info-shipment-item-row-key">{{ "LABELS.ARRIVAL_DATE" | translate }}</div>
              <div class="info-shipment-item-row-value" [ngClass]="{ 'text-error': arrivalDateErrorText && !isHasEsOcrRedesign }">
                <ng-container *ngIf="!isHasEsOcrRedesign">
                  {{ entrySummary.arrivalDate ? (entrySummary.arrivalDate | customDateByUtc) : (arrivalDateErrorText | translate) }}
                </ng-container>

                <ng-container *ngIf="isHasEsOcrRedesign && !!entrySummary.arrivalDate">
                  {{ entrySummary.arrivalDate | customDateByUtc }}
                </ng-container>

                <ng-container *ngIf="isHasEsOcrRedesign && !entrySummary.arrivalDate">
                  {{ "-----" }}
                </ng-container>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <div class="info-shipment-item-wrapper is-last" *ngIf="isWithVia">
        <div
          class="info-shipment-item"
          [ngClass]="{ 'has-error': isEmpty || isAllViaFieldsMissing, 'is-editable': isCanEdit, 'is-last': true }"
          *ngIf="isWithVia"
        >
          <div class="info-shipment-item-header">
            <h3>{{ "ENTRY_SUMMARY.VIA" | translate }}</h3>

            <button
              type="button"
              class="btn btn-link d-print-none ml-2"
              [ngClass]="{ 'info-shipment-main__edit-button': isHasEsOcrRedesign }"
              *ngIf="(canEditVia ?? isCanEdit) && !isAllViaFieldsMissing"
              (click)="editVia.emit()"
            >
              <svg width="19" height="19" viewBox="0 0 19 19" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M0 14.2525V18.0025H3.75L14.81 6.9425L11.06 3.1925L0 14.2525ZM17.71 4.0425C18.1 3.6525 18.1 3.0225 17.71 2.6325L15.37 0.2925C14.98 -0.0975 14.35 -0.0975 13.96 0.2925L12.13 2.1225L15.88 5.8725L17.71 4.0425Z"
                  fill="currentColor"
                />
              </svg>
            </button>
          </div>

          <div *ngIf="isAllViaFieldsMissing && (canEditVia ?? isCanEdit)" class="info-shipment-item__missing-fields">
            <div class="info-shipment-item__missing-fields__edit-button" (click)="editVia.emit()">
              <img class="info-shipment-item__missing-fields__edit-button__icon" src="assets/icons/icon_edit_gray_md.svg" alt="edit" />
            </div>
          </div>

          <div class="info-shipment-item-row" *ngIf="location && !isAllViaFieldsMissing">
            <div class="info-shipment-item-row-key">{{ "FORM_LABEL.PORT_OF_UNLADING_ARRIVAL" | translate }}</div>

            <div class="info-shipment-item-row-value" [ngClass]="{ 'text-error': unladingErrorText && !isHasEsOcrRedesign }">
              <span *ngIf="!unladingErrorText">{{ portOfUnlading ? portOfUnlading.code + " " + portOfUnlading.description : "" }}</span>
              <span *ngIf="!isHasEsOcrRedesign && unladingErrorText">{{ unladingErrorText | translate }}</span>
              <span *ngIf="isHasEsOcrRedesign && unladingErrorText">-----</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
